// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function InformationHome() {
    return (
        <MKBox component="section" pt={{ xs: 8, md: 10 }} pb={{ xs: 3, md: 5 }}>
            <Container>
                <Grid
                    container
                    item
                    xs={12}
                    lg={10}
                    justifyContent="center"
                    sx={{ mx: "auto" }}
                >
                    <MKTypography
                        variant="h2"
                        color="dark"
                        mb={3}
                        sx={{ textWrap: "balance" }}
                    >
                        Ce este Curățenia Generală?
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={3} sx={{ textWrap: "pretty" }}>
                        Curățenia generală reprezintă un proces complex de curățare, care include:
                        desprafuirea și aspirarea tuturor suprafețelor, ștergerea mobilierului atât
                        la exterior, cât și la interior, degresarea mobilierului de bucătărie și a
                        electrocasnicelor, igienizarea grupurilor sanitare, spălarea ferestrelor,
                        curățarea pardoselilor, aplicarea tratamentelor pentru pardoseli, precum și
                        curățarea suprafețelor textile (saltele, scaune, fotolii, mochete și
                        covoare).
                    </MKTypography>

                    <MKTypography variant="h3" color="dark" mt={2} mb={2} sx={{ textWrap: "balance" }}>
                        Dar ce poate fi mai mult decât o Curățenie Generală?
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={3} sx={{ textWrap: "pretty" }}>
                        <strong>Curățenia Generală Detaliată</strong> este un serviciu impecabil,
                        prin care toate suprafețele sunt tratate până la cele mai fine detalii.
                        Acest serviciu include, în special: retușuri post-construcție, curățarea
                        feroneriei, a chederelor și a sistemelor de etanșare, îndepărtarea
                        materialelor de construcție dificile (materiale decorative, silicon, spumă
                        poliuretanică, adezivi, folie lichidă), precum și tratamente speciale de
                        curățare și igienizare cu abur. De asemenea, sunt aplicate tratamente de
                        curățare în profunzime, precum degresări, decapări și decalcăriri.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={3} sx={{ textWrap: "pretty" }}>
                        Acest tip de serviciu, indiferent de destinația spațiului – rezidențial,
                        comercial, industrial sau de afaceri – este realizat cu ajutorul celor mai
                        avansate echipamente tehnologice moderne și de către personal experimentat,
                        format din agenți calificați și pregătiți profesional.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" sx={{ textWrap: "pretty" }}>
                        Ne mândrim cu proiecte de anvergură, adresate unor domenii cu standarde
                        ridicate: restaurante și bucătării de lux, hoteluri, spații de birouri de
                        clasă A, sedii de companii, spații tehnice și laboratoare de producție
                        medicală și farmaceutică, unități de producție alimentară și gelaterii,
                        precum și showroom-uri de mobilier de lux.
                    </MKTypography>
                </Grid>
            </Container>
        </MKBox>
    );
}

export default InformationHome;
